import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons } from '../icons';
import Translate from '../layout/Translate';

export default class Switch extends Component {

    componentDidMount() {
        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }

    setMapActive(){
    }

    setBoundedObjects() {
        //console.log('!!!!!!!!');
    }

    render () {
        let translations = {on_map: 'On map', by_list: 'List'};


        return (
            <div className={"switch "}>
                <Link to={'/map'} className={"switch__label"} >
                    <Translate slug="controls__map" />
                </Link>
                <Link to={this.props.active?'/tours':'/map'} className={"switch__area"} onClick={this.setBoundedObjects.bind(this)}>
                    <div className={"switch__slider " + ((this.props.active)?'switch__slider_active':'')}></div>
                </Link>

                <Link to={'/tours'} className={"switch__label"} >
                    <Translate slug="controls__list" />
                </Link>
            </div>



        );
    }
};



// WEBPACK FOOTER //
// ./src/common/components/map/Switch.js